import { Component, ContentChild } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { NotificationsComponent, NotificationsManager } from '../../notifications.factory';

@Component({
    selector: 'ca-notifications-alarm',
    templateUrl: './notifications-alarm.component.html',
    styleUrls: ['./notifications-alarm.component.scss'],
})
export class NotificationsAlarmComponent {
    @ContentChild(NotificationsComponent) content: NotificationsManager;

    get hasNotifications$(): Observable<boolean> {
        return this.content?.notifications$.pipe(map(notifications => notifications.size > 0));
    }

    get hasAlerts$(): Observable<boolean> {
        return this.content?.notifications$.pipe(map(notifications => [...notifications.values()].some(notification => notification.severity === 'alert')));
    }
}
